/**
 * Created by zhengyf on 2017/12/20.
 */

/**
 * navTitle 导航栏标题
 * menuList 导航栏菜单
 * menuList = [
 *      {
 *          title: '导航栏名字',
 *          href: '链接',
 *          strong: true, // 加粗 加下边框
 *          current: true // 当前选中
 *      }
 * ]
 * boxStyle 导航栏最外层元素样式
 * hoverMenuMode 悬浮的菜单栏模式 mini || large
 */

;(function() {

    angular
        .module('DSSXAPP')
        .component('dsMenuLeft', {
            template:'<div class="ds-common-component ds-common-component-menu-left" ng-style="vm.c.boxStyle"><div class="manager-wrap"><div class="navigation-menu-manager"><div class="navigation-manager-title"><span class="m-t-wrap"><span class="n-biz-title-text" ng-attr-title="{{vm.c.navTitle}}" ng-bind="vm.c.navTitle"></span></span></div><div class="manager-main"><div class="m-t-icon-wrap"><i class="m-t-icon"></i><hover-nav-menu-left class="box-aim" mode="vm.c.hoverMenuMode"></hover-nav-menu-left></div></div></div></div><div class="n-menu-left-box"><ul class="n-menu-left-list"><li ng-repeat="item in vm.c.menuList track by $index"><div class="group-title" ng-bind="item.title" ng-if="item.strong"></div><a ng-href="{{item.href}}" target="_blank" ng-if="!item.strong" ng-bind="item.title" ng-class="{\'current\': item.current}"></a></li></ul></div></div>',
            bindings: {
                navTitle: '<',
                menuList: '<',
                boxStyle: '<',
                hoverMenuMode: '<'
            },
            controllerAs: 'vm',
            controller: DsMenuLeftCtrl
        });

    function DsMenuLeftCtrl() {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        vm.c = {
            navTitle: '',
            menuList: [],
            boxStyle: {
                width: ''
            },
            hoverMenuMode: ''
        };

        function onInit() {
            console.log('[DsMenuLeftCtrl init: ]');
        }

        function bindingsOnChanges(changes) {

            if(changes.navTitle) {
                vm.c.navTitle = vm.navTitle || '采购直达';
            }

            if(changes.menuList) {
                vm.c.menuList = vm.menuList || [];
            }

            if (changes.boxStyle) {
                vm.c.boxStyle = vm.boxStyle || {width: '174px'};
            }

            if (changes.hoverMenuMode) {
                vm.c.hoverMenuMode = vm.hoverMenuMode || 'mini';
            }
        }
    }

})();
